// extracted by mini-css-extract-plugin
module.exports = {"roundIcon":"pw","disabled":"px"};